import React from 'react';
import '../../../Components/common/Modal/modal.css';
import './RuntimeConfigPanel.css';
import { formatOverlapDetails } from './proxyRouteUtils';

const OverlapConflictItem = ({ detail, index, total }) => (
  <li className="runtime-config-overlap-item" data-testid={`overlap-item-${index}`}>
    {total > 1 && (
      <div className="runtime-config-overlap-item-title">
        {`Conflict ${index + 1}`}
      </div>
    )}
    <dl className="runtime-config-overlap-item-details">
      <div className="runtime-config-overlap-detail-row">
        <dt>Broader route</dt>
        <dd>{detail.parentRoute}</dd>
      </div>
      <div className="runtime-config-overlap-detail-row">
        <dt>Overlapping route</dt>
        <dd>
          {detail.isNested ? (
            <>
              <span className="runtime-config-overlap-route-name">{detail.nestedName}</span>
              {' '}
              <span className="runtime-config-overlap-route-context">
                {`(under ${detail.parentRoute})`}
              </span>
            </>
          ) : (
            detail.childRoute
          )}
        </dd>
      </div>
      {detail.targetConflict && (
        <div className="runtime-config-overlap-detail-row runtime-config-overlap-detail-conflict">
          <dt>Target conflict</dt>
          <dd>
            {detail.targetConflict.parent}
            {' vs '}
            {detail.targetConflict.child}
          </dd>
        </div>
      )}
      {detail.rerouteConflict && (
        <div className="runtime-config-overlap-detail-row runtime-config-overlap-detail-conflict">
          <dt>Reroute conflict</dt>
          <dd>
            {detail.rerouteConflict.parent}
            {' vs '}
            {detail.rerouteConflict.child}
          </dd>
        </div>
      )}
      <div className="runtime-config-overlap-detail-row">
        <dt>Longer match wins</dt>
        <dd>{detail.winnerRoute}</dd>
      </div>
    </dl>
  </li>
);

const OVERLAP_OPERATION_NOTE = {
  remove: 'Confirm to complete the remove. Existing overlapping routes stay in the config; the longest matching prefix still wins.',
  merge: 'Apply anyway? The longest matching prefix wins.',
};

const OverlapConfirmModal = ({
  overlaps,
  summary,
  operation,
  submitting = false,
  onConfirm,
  onCancel,
}) => {
  const details = formatOverlapDetails(overlaps);
  const hasStructuredDetails = details.length > 0;

  if (!hasStructuredDetails && !summary) {
    return null;
  }

  return (
    <div
      className="bulk-upload-soft-delete-overlay runtime-config-overlap-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="runtime-config-overlap-title"
      data-testid="overlap-confirm-modal"
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div
        className="bulk-upload-soft-delete-dialog runtime-config-overlap-dialog"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="instructions delete-folder-modal-main bulk-upload-filename-space-body runtime-config-remove-modal-main">
          <div className="delete-folder-modal-copy-delete">
            <p
              className="delete-folder-note bulk-upload-filename-space-note runtime-config-remove-message"
              id="runtime-config-overlap-title"
            >
              <strong>Prefix overlap detected</strong>
            </p>
            {hasStructuredDetails ? (
              <ul className="runtime-config-overlap-list">
                {details.map((detail, index) => (
                  <OverlapConflictItem
                    key={`${detail.parentRoute}-${detail.childRoute}-${index}`}
                    detail={detail}
                    index={index}
                    total={details.length}
                  />
                ))}
              </ul>
            ) : (
              <p className="runtime-config-overlap-summary">{summary}</p>
            )}
            <p className="runtime-config-overlap-note">
              {OVERLAP_OPERATION_NOTE[operation] || OVERLAP_OPERATION_NOTE.merge}
            </p>
          </div>
          <div className="delete-folder-actions">
            <input
              type="button"
              className="unzip-formButton"
              value="Cancel"
              onClick={onCancel}
              disabled={submitting}
              data-testid="overlap-cancel-btn"
            />
            <input
              type="button"
              className="unzip-formButtonGo"
              value={submitting ? 'Applying…' : 'Apply anyway'}
              onClick={onConfirm}
              disabled={submitting}
              data-testid="overlap-confirm-btn"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverlapConfirmModal;
